import { render, staticRenderFns } from "./SafetyReport.vue?vue&type=template&id=34fca0f0&scoped=true&"
import script from "./SafetyReport.vue?vue&type=script&lang=js&"
export * from "./SafetyReport.vue?vue&type=script&lang=js&"
import style0 from "./SafetyReport.vue?vue&type=style&index=0&id=34fca0f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fca0f0",
  null
  
)

export default component.exports